export class AtribuiTarefa{
  id: number;
  responsavelId: number;
  status: number;
}
